import { Suspense } from 'react'
import { Link, useParams } from 'react-router-dom'

import RecipeView from '@/recipe/components/RecipeView'
import Loader from '@/components/Loader'
import logo from '@/assets/logo.svg'

export const PublicRecipe = () => {
  const { shareToken } = useParams()
  return (
    <div className="flex h-full flex-col items-center overflow-y-auto p-4">
      <Link to="/" className="flex items-center gap-2 rounded-full bg-white/5 px-5 py-1 shadow-md hover:bg-white/10">
        <img src={logo} alt="RecipeVision logo" className="h-10 w-10" />
        <span className="text-white">Recipe Vision AI</span>
      </Link>
      <Suspense fallback={<Loader />}>
        <RecipeView shareToken={shareToken as string} />
      </Suspense>
    </div>
  )
}

export default PublicRecipe
